import { Group, Select, Stepper, Text } from "@mantine/core";
import { useLanguage } from "../../../../../../stores/LanguageStore";
import { useMemo } from "react";
import { useLeadsSheetStore } from "../../../../../../stores/LeadsStore";
import AddReminder from "../Right/reminder/AddReminder";
import ReminderItem from "../Right/reminder/ReminderItem";
import { IconArrowDown, IconArrowUp } from "@tabler/icons-react";

const TabRemindersMobile = () => {
  const lang = useLanguage((s) => s.language);
  const current = useLeadsSheetStore((s) => s.current);

  const sort = useLeadsSheetStore((s) => s.sort);
  const setSort = useLeadsSheetStore((s) => s.setSort);

  const orders = useMemo(() => {
    return [
      {
        label: lang.prm.details.filters.desc,
        value: "desc",
      },
      {
        label: lang.prm.details.filters.asc,
        value: "asc",
      },
    ];
  }, [lang.prm.details.filters.asc, lang.prm.details.filters.desc]);

  return (
    <>
      <Text size="lg" my={-8}>
        {lang.leads.tabs.reminders}
      </Text>
      <Group mb={"lg"} justify="space-between">
        <Select
          value={sort}
          data={orders}
          w={190}
          size="xs"
          onChange={setSort}
          leftSection={
            sort === "asc" ? (
              <IconArrowUp size={18} />
            ) : (
              <IconArrowDown size={18} />
            )
          }
        />

        <AddReminder isMobile />
      </Group>
      <Stepper
        active={0}
        iconSize={28}
        size="sm"
        radius={"lg"}
        styles={{ stepIcon: { border: "none", background: "none" } }}
        orientation="vertical"
      >
        {current?.calls?.map((item, index) => (
          <ReminderItem
            key={item?.id || index}
            item={item}
            isLast={index === current.calls.length - 1}
            isMobile
          />
        ))}
      </Stepper>
    </>
  );
};

export default TabRemindersMobile;
